import { render, staticRenderFns } from "./BContact.vue?vue&type=template&id=2fcd2610&scoped=true&"
import script from "./BContact.vue?vue&type=script&lang=js&"
export * from "./BContact.vue?vue&type=script&lang=js&"
import style0 from "./BContact.vue?vue&type=style&index=0&id=2fcd2610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd2610",
  null
  
)

export default component.exports